import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BackofficeEispraksiTransformer  {
    _originalTypeClassName = "zERP.BO.BackofficeEispraksiTransformer";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BackofficeEispraksiTransformer.translate = translateService;
}
this.BackofficeEispraksiTransformerKey = null;
this._key = this.BackofficeEispraksiTransformerKey = 0; 
}

static translate: TranslateService;
_key: any;
private _BackofficeEispraksiTransformerKey:any;
get BackofficeEispraksiTransformerKey(): any {
    return this._BackofficeEispraksiTransformerKey;
  }
set BackofficeEispraksiTransformerKey(value: any) {
    this._BackofficeEispraksiTransformerKey = value;
    this._key = value;
  }

static GetReason(document: any,invoice: any,takingReason: any): any{let lines = [];
if (CLMS.Framework.Number.NotEqual(() => document.clientId, () => null) && CLMS.Framework.Number.GreaterThan(() => document.clientId, () => 0)) {lines?.add(Domain.BackOfficeUtilities.GetTransactionEntityDescription(invoice?.TransactionEntity));}
if (!(CLMS.Framework.String.IsNullOrEmpty((document.receiptNo ?? '').trim()))) {lines?.add("Αρ. Απόδειξης: " + document.receiptNo);}
if (takingReason != null) {lines?.add(takingReason?.BackofficeDescription);}
return CLMS.Framework.String.Join("\r\n", lines);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.BackofficeEispraksiTransformerKey == null || $this.BackofficeEispraksiTransformerKey == 0;
            }


}